import styled from 'styled-components';
import { Border, BorderRadius, BoxShadow, Colors, FontSize, FontWeight, Spacing } from 'web-common/src/shared/styles';
import { PanelCard } from '../ScrollSnapPanels/PanelCard';

export const StyledPanelCard = styled(PanelCard)`
  height: 580px;
  width: 300px;
  border: none;
  box-shadow: none;
`;

export const StyledImage = styled.img`
  border-radius: ${BorderRadius.M} ${BorderRadius.M} 0 0;
`;

export const StyledCategory = styled.div`
  font-size: ${FontSize.S};
  font-weight: ${FontWeight.BOLD};
  color: ${Colors.PLUM_DARK_10};
`;

export const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacing.SINGLE};
  align-items: center;
`;

// A little bit hacky, but may be necessary to achieve the dish sticking out look
export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 320px;
  padding: ${Spacing.SINGLE_QUARTER};
  justify-content: space-between;
  border: ${Border.Base} ${Colors.GRAY_LITE_20};
  border-radius: 0 0 ${BorderRadius.M} ${BorderRadius.M};
  box-shadow: ${BoxShadow.HOMEPAGE_HERO_CONTENT};
`;

export const StyledDishTitle = styled.h4`
  font-size: ${FontSize.M};
  font-weight: ${FontWeight.BOLD};
`;

export const StyledDescription = styled.p`
  margin-top: ${Spacing.QUARTER};
  color: ${Colors.GRAY_DARK_15};
`;

export const ShefDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-content: flex-start;
`;

export const ShefName = styled.span`
  font-size: ${FontSize.S};
  font-weight: ${FontWeight.SEMI_BOLD};
`;

export const StyledDishImage = styled.img`
  transform: translateY(-25%);
  width: 248px;
  height: 248px;
`;

export const BackgroundContainer = styled.div<{ backgroundImage: string }>`
  border-radius: ${BorderRadius.M} ${BorderRadius.M} 0 0;
  background-image: url(${({ backgroundImage }) => backgroundImage});
  height: 180px;
  width: 300px;
  display: flex;
  justify-content: center;
`;

export const ImageContainer = styled.div`
  height: 260px;
  display: flex;
  align-items: flex-end;
  border-width: 0;
`;

export const TopRow = styled.div`
  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DishRow = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const DesktopContainer = styled.div`
  width: 100vw;
`;
